import React, { useState } from "react";
import Select from '../components/ui/Select.tsx';
import { useIsAdmin }from  "../hooks/useIsAdmin.ts"
import { useGetProfile } from '../hooks/useProfile.ts';

interface TableBankingLoanFormProps {
  loan?: any;
  onSubmit: (data: any) => void;
  onClose: () => void;
  members: { id: number; name: string; phone_number?: string }[];
}

const TableBankingLoanForm: React.FC<TableBankingLoanFormProps> = ({ members, loan, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    principal_amount: loan?.principal_amount || 0,
    reason: loan?.reason || "",
    repayment_date: loan?.repayment_date || "",
  });

  const memberOptions = members?.map(m => ({ value: m.id, label: `${m.name} (${m.phone_number || ''})` })) || [];
  const [selectedMember, setSelectedMember] = useState(memberOptions.find(opt => opt.value === loan?.memberId) || null);
  const isAdmin = useIsAdmin();
  const { data: profileData } = useGetProfile();
  const  memberId = profileData?.data?.member_id;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'principal_amount' ? parseFloat(value) : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const member = isAdmin ? selectedMember?.value : memberId
    if (!member)  return alert("Please select a member");

    await onSubmit({
      member_id:  member,
      ...formData,
    });

    setFormData({ principal_amount: 0, reason: '', repayment_date: '' });
    setSelectedMember(null);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 border rounded-md shadow-sm">
      {isAdmin && (
            <div>
             <label className="block font-medium">Member</label>
              <Select
                  options={memberOptions}
                  value={selectedMember}
                  onChange={setSelectedMember}
                  isClearable
                  placeholder="Select member..."
                />
             </div>

      )}
      <div>
        <label>Loan Amount</label>
        <input
          type="number"
          name="principal_amount"
          value={formData.principal_amount}
          onChange={handleChange}
          required
          min={0}
          className="border p-2 w-full rounded"
        />
      </div>

      <div>
        <label>Loan Purpose</label>
        <textarea
          name="reason"
          value={formData.reason}
          onChange={handleChange}
          required
          className="border p-2 w-full rounded"
        />
      </div>

      <div className="flex justify-end gap-2">
        <button type="button" onClick={onClose} className="px-4 py-2 text-gray-700 dark:text-gray-200 bg-gray-200 dark:bg-gray-600 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500">Cancel</button>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">Submit</button>
      </div>
    </form>
  );
};

export default TableBankingLoanForm;
